jQuery(function($) {
  $("#wishl-wrapper").on("listcomplete.wishl", function() {
    $(this).find('.wishl-product-list-item').each(function(index) {
      const variantId = $(this).attr('data-variant');
      $(this).find('.wishl-select').val(variantId);
      for(var i = 1; i < 4; i++) {
        const optionValue = $(this).attr('data-option'+i);
        const optionEl    = $(this).find('[data-position="option'+i+'"]');
        if(optionValue && optionEl) {
          $(optionEl).find('option[value="'+optionValue+'"]').attr('selected', 'selected');
        }
      }
    });
    window.addEventListener('change', function(evt) {
      if(evt.target.classList.contains('wishl-select-multi')) {
        const productEl = evt.target.closest('.wishl-product-list-item');
        var optionSelectAttr = '';
        productEl.querySelectorAll('.wishl-select-multi').forEach(function(el, index0) {
          optionSelectAttr = optionSelectAttr+'[data-option'+(index0+1)+'="'+el.value+'"]';
        });
        const newVariantId = productEl.querySelector('.wishl-select option'+optionSelectAttr).value;
        productEl.querySelector('form input[name="id"]').value = newVariantId;
      }
    });

  });
});
